import React from 'react';
import { PrivacyPolicy } from '@medtrail/shared-ui';
import Header from '../../components/header';
import { ROUTE_FLAG, WEBSITE } from '../../constants';


const privacyPolicy = () => {

  return (
    <React.Fragment>
      <div className='headerContainer'>
        <Header active={null} routeFlag={ROUTE_FLAG.paymentPolicyPage}/>
      </div>
      <PrivacyPolicy website={WEBSITE}/>
    </React.Fragment>
  );

};

export default privacyPolicy;
